export function useIsHeaderTag(value) {
  return (
    ["h1", "h2", "h3", "h4", "h5", "h6"].indexOf(value.toLowerCase()) !== -1
  );
}

export function useIsBgColor(value) {
  return (
    ["blue", "navy", "gray", "orange", "dark orange", "white"].indexOf(
      value.toLowerCase()
    ) !== -1
  );
}

export function useCustomValidator(props, value) {
  return props.indexOf(value.toLowerCase()) !== -1;
}
